import { render, staticRenderFns } from "./customerreport.vue?vue&type=template&id=26e88788&scoped=true&"
import script from "./customerreport.vue?vue&type=script&lang=js&"
export * from "./customerreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e88788",
  null
  
)

export default component.exports